<template>
  <span :class="badgeClass">{{ label }}</span>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  status: {
    type: String,
    default: "pending",
  },
});

const label = computed(() => props.status || "pending");

const badgeClass = computed(() => {
  const status = (props.status || "pending").toLowerCase();
  if (status.includes("done") || status.includes("complete")) return "lamella-badge lamella-badge--done";
  if (status.includes("milling") || status.includes("lift")) return "lamella-badge lamella-badge--active";
  if (status.includes("fail") || status.includes("error")) return "lamella-badge lamella-badge--alert";
  return "lamella-badge lamella-badge--idle";
});
</script>

<style scoped>
.lamella-badge {
  display: inline-flex;
  align-items: center;
  border-radius: 999px;
  padding: 0.2rem 0.55rem;
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.lamella-badge--idle { background: #e5e7eb; color: #374151; }
.lamella-badge--active { background: #dbeafe; color: #1d4ed8; }
.lamella-badge--done { background: #dcfce7; color: #166534; }
.lamella-badge--alert { background: #fee2e2; color: #b91c1c; }
</style>
